import { twMerge } from 'tailwind-merge'

type BoxProps = {
  children: React.ReactNode
} & React.ComponentPropsWithoutRef<'div'>

export default function Box({ className, children }: BoxProps) {
  className = twMerge('relative px-6 py-4 rounded ring-1 ring-zinc-200 dark:ring-zinc-700 bg-zinc-50 dark:bg-zinc-900', className)

  return <div className={className}>{children}</div>
}
